import type { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import styles from './Login.module.css';
import { AuthAmbientBackdrop } from './AuthAmbientBackdrop';

export type AuthPageShellVariant = 'split' | 'center';

export type AuthPageShellProps = {
  children: ReactNode;
  /** Left column at lg+; hidden below lg. Only used when variant is split. */
  copy?: React.ReactNode;
  variant?: AuthPageShellVariant;
  /** Props for the motion wrapper around `copy` (e.g. initial / animate). */
  copyMotionProps?: Omit<ComponentProps<typeof motion.div>, 'children' | 'className'>;
  /** Applies section2 height tweaks used by sign-up. */
  fillViewportHeight?: boolean;
};

export function AuthPageShell({
  children,
  copy,
  variant = 'split',
  copyMotionProps,
  fillViewportHeight = false,
}: AuthPageShellProps) {
  const showCopy = variant === 'split' && copy != null;
  const layoutClass = showCopy ? styles.layoutWrap : styles.layoutWrapCentered;
  const sectionClass = fillViewportHeight ? `${styles.section} ${styles.section2}` : styles.section;

  return (
    <section className={sectionClass}>
      <div
        className={clsx(styles.ringsBackdropWrap, showCopy && styles.ringsBackdropWrapSplit)}
        aria-hidden
      >
        <AuthAmbientBackdrop />
      </div>
      <div className={layoutClass}>
        {showCopy && (
          <motion.div className={styles.copyColumn} {...(copyMotionProps ?? {})}>
            {copy}
          </motion.div>
        )}
        <div className={styles.cardColumn}>{children}</div>
      </div>
    </section>
  );
}
